// extracted by mini-css-extract-plugin
export default {"form":"styles_form__bL+uC","input":"styles_input__FwYug","select":"styles_select__80Sds","submitButton":"styles_submitButton__Q4Ok7"};